import React, { useState } from "react";
import { FaWhatsapp, FaPhoneAlt } from "react-icons/fa";
import { motion } from "framer-motion";
import { CheckCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {API_URL,FAST_API_URL} from "../api"

const ReminderPreference = () => {
  const navigate = useNavigate();

  const [selected, setSelected] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false); // <-- 🔄 Loader state

  const handleSubmit = async () => {
    if (!selected) {
      alert("Please select a reminder method.");
      return;
    }

    setLoading(true); // 🔄 Start loader

    try {
      let headersList = {
        Accept: "*/*",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      };

      await axios.post(
        `${API_URL}/add_user_message_type_webside`,
        { medicines_reminder: selected },
        { headers: headersList }
      );

      setSubmitted(true);
      navigate("/reminder_book");
    } catch (err) {
      console.error("Submission failed:", err);
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false); // 🔄 Stop loader
    }
  };

  return (
    <div className="w-full min-h-screen flex flex-col justify-center items-center bg-gradient-to-br from-teal-400 via-green-300 to-blue-200 p-6">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-xl bg-white/90 backdrop-blur-sm rounded-3xl shadow-2xl p-8 space-y-6"
      >
        <h2 className="text-3xl font-bold text-center text-gray-800">
          ⏰ Choose How You Want To Receive Reminders
        </h2>

        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
          {/* WhatsApp Option */}
          <motion.div
            whileTap={{ scale: 0.96 }}
            onClick={() => setSelected("whatsapp")}
            className={`w-full sm:w-1/2 cursor-pointer border-2 rounded-xl p-6 text-center transition-all duration-300 ${
              selected === "whatsapp"
                ? "border-green-500 bg-green-50 shadow-md"
                : "border-gray-300 bg-white"
            }`}
          >
            <div className="flex justify-center text-green-600 text-3xl mb-2">
              <FaWhatsapp />
            </div>
            <div className="text-xl font-semibold text-gray-700">WhatsApp</div>
            <p className="text-sm text-gray-500">Get reminders via message</p>
            {selected === "whatsapp" && (
              <div className="mt-3 text-green-600 flex justify-center items-center gap-1">
                <CheckCircle size={18} /> Selected
              </div>
            )}
          </motion.div>

          {/* Voice Call Option */}
          <motion.div
            whileTap={{ scale: 0.96 }}
            onClick={() => setSelected("voice")}
            className={`w-full sm:w-1/2 cursor-pointer border-2 rounded-xl p-6 text-center transition-all duration-300 ${
              selected === "voice"
                ? "border-blue-500 bg-blue-50 shadow-md"
                : "border-gray-300 bg-white"
            }`}
          >
            <div className="flex justify-center text-blue-600 text-2xl mb-2">
              <FaPhoneAlt />
            </div>
            <div className="text-xl font-semibold text-gray-700">Voice Call</div>
            <p className="text-sm text-gray-500">Get reminders via phone call</p>
            {selected === "voice" && (
              <div className="mt-3 text-blue-600 flex justify-center items-center gap-1">
                <CheckCircle size={18} /> Selected
              </div>
            )}
          </motion.div>
        </div>

        {/* Submit Button with Loader */}
        <motion.button
          whileTap={{ scale: 0.96 }}
          onClick={handleSubmit}
          disabled={loading}
          className="w-full mt-6 bg-blue-600 hover:bg-blue-700 text-white text-lg font-semibold py-2 rounded-xl shadow-lg flex items-center justify-center gap-2"
        >
          {loading ? (
            <>
              <svg
                className="animate-spin h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v8H4z"
                ></path>
              </svg>
              Saving...
            </>
          ) : (
            "Save Preference"
          )}
        </motion.button>
      </motion.div>
    </div>
  );
};

export default ReminderPreference;
